module.exports = __webpack_public_path__ + "img/work_from_anywhere5.3f2278f6.png";